import { FieldNames } from 'Constants/FieldNames'
import { SETTING_KEY_USER } from 'Modules'

export enum TYPE_PARTNER_DOCUMENT {
	DOCUMENTS = 'documents',
	CONTRACT_DOCUMENTS = 'contract_documents',
}

export enum STATUS_PARTNER {
	DISTRIBUTED_LEAD = 'distributed_lead',
	UNDISTRIBUTED_LEAD = 'undistributed_lead',
	NEW_PARTNER = 'new_partner',
	DELETED = 'deleted',
	POTENTIAL = 'potential',
}

export const DEFAULT_FILTER = {
	[FieldNames.STATUS_SLUG]: `${STATUS_PARTNER.DISTRIBUTED_LEAD},${STATUS_PARTNER.UNDISTRIBUTED_LEAD}`,
}

export const SETTINGS_KEY = SETTING_KEY_USER.PARTNER_ONE_DAY
